import React from "react";

interface StraightLineProgressProps {
  percentage: number;
  color?: "primary" | "success" | "warning" | "info" | "error";
}

const StraightLineProgress: React.FC<StraightLineProgressProps> = ({
  percentage,
  color = "primary",
}) => {
  return (
    <div className="w-full h-2 bg-gray-200 rounded-full mt-2">
      <div
        className={`h-full rounded-full animate-fade-in ${
          color === "primary"
            ? "bg-[var(--app-primary)]"
            : color === "success"
            ? "bg-[var(--status-success)]"
            : color === "warning"
            ? "bg-[var(--status-warning)]"
            : color === "info"
            ? "bg-[var(--status-info)]"
            : color === "error"
            ? "bg-[var(--status-error)]"
            : "bg-[var(--app-primary)]"
        }`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default StraightLineProgress;
